// Zoom levels for the farm map view.
//
// The farm map view uses a custom list of levels of detail (LODs) with two
// entries per standard web-mercator zoom level, so each zoom step (the +/-
// buttons, the +/- keys, double-click and the mouse wheel) changes the scale by
// about 1.41x instead of 2x.
//
// ArcGIS numbers `view.zoom` by position in the LOD list, so on this view it
// reads double the familiar web-mercator number. App code should not pass zoom
// numbers to this view; pass a scale from scaleForZoom() instead.
//
// No SDK imports, so this file can be checked from Node.

const STEPS_PER_LEVEL = 2;
const BASE_LEVEL_COUNT = 24; // standard levels 0 to 23

// Web-mercator level 0 scale, matching the SDK's TileInfo.create() default.
const LEVEL_0_SCALE = 591657527.591555;
const SCREEN_DPI = 96;
const INCHES_PER_METRE = 39.37;

// Scale of a standard web-mercator zoom level (fractional levels allowed).
export function scaleForZoom(webMercatorZoom) {
  return LEVEL_0_SCALE / 2 ** webMercatorZoom;
}

// LOD list for MapView `constraints.lods`: STEPS_PER_LEVEL entries per standard
// level, evenly spaced in log scale, ending exactly at the last standard level.
// Entry index = standard level * STEPS_PER_LEVEL.
export function buildFineLods() {
  const lods = [];
  const lastIndex = (BASE_LEVEL_COUNT - 1) * STEPS_PER_LEVEL;
  for (let index = 0; index <= lastIndex; index++) {
    const scale = scaleForZoom(index / STEPS_PER_LEVEL);
    lods.push({
      level: index,
      scale,
      resolution: scale / (INCHES_PER_METRE * SCREEN_DPI),
    });
  }
  return lods;
}
